<h2 class="form__title">Alert Notification</h2>

<ul class="table__control inline-list">
  <li>
    <button mat-raised-button (click)="onNoClick()" color="accent">Close</button>
  </li>
  <li>
    <button mat-raised-button [mat-dialog-close]="data" cdkFocusInitial
      [disabled]="alertForm.invalid || !(data?.propertiesObj?.AlertEmailAdresses?.length > 0)"
      color="primary">{{data?.id ? 'Update' : 'Add' }}</button>
  </li>
</ul>

<ng-form #alertForm="ngForm" novalidate class="form__cont">
  <h3 class="full__section">Alert Information</h3>

  <div class=" form-container">
    <app-multiselect-email [required]="true" name="AlertEmailAdresses"
      [(ngModel)]="data.propertiesObj.AlertEmailAdresses" label="Recipients"
      matTooltip="The list of recipients for this event notification">
    </app-multiselect-email>
  </div>

  <div class="form-container">
    <section class="custom-check-box-group">
      <mat-checkbox class="custom-check-box" name="AlertTrackTask" [(ngModel)]="data.propertiesObj.AlertTrackTask">Track
        Task</mat-checkbox>
    </section>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline" matTooltip="The date on which the event notification should be sent">
      <mat-label>Event Alert Date</mat-label>
      <input #AlertDueDate="ngModel" name="AlertDueDate" [(ngModel)]="data.propertiesObj.AlertDueDate" matInput
        [matDatepicker]="pickerAlertDueDate" placeholder="Choose a date yyyy/mm/dd" required [min]="tomorrow" />
      <mat-datepicker-toggle matSuffix [for]="pickerAlertDueDate">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerAlertDueDate></mat-datepicker>
      <mat-error *ngIf="AlertDueDate?.errors?.required">
        Field is required in format yyyy/mm/dd
      </mat-error>
      <mat-error *ngIf="AlertDueDate?.errors?.matDatepickerMin">
        Date should be after today
      </mat-error>
    </mat-form-field>
  </div>



  <!-- <div class="form-container">
    <mat-form-field appearance="outline" matTooltip="The date on which the event notification was sent">
      <mat-label>Alert Sent Date</mat-label>
      <input #AlertSendDate="ngModel" name="AlertSendDate" [(ngModel)]="data.propertiesObj.AlertSendDate" matInput
        [matDatepicker]="pickerAlertSendDate" placeholder="Choose a date yyyy/mm/dd" disabled />
      <mat-datepicker-toggle matSuffix [for]="pickerAlertSendDate">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerAlertSendDate></mat-datepicker>
      <mat-error *ngIf="AlertSendDate?.errors?.required">
        Field is required in format yyyy/mm/dd
      </mat-error>
      <mat-error *ngIf="AlertSendDate?.errors?.matDatepickerMin">
        Date should be after today
      </mat-error>
    </mat-form-field>
  </div> -->

  <div class="form-container full__section">
    <mat-form-field appearance="outline">
      <mat-label>Reminder Text</mat-label>
      <input #AlertMessageText="ngModel" maxlength="4000" name="AlertMessageText" matInput
        [(ngModel)]="data.propertiesObj.AlertMessageText" required
        matTooltip="Text to be included in the email that will be sent when the event notification is triggered. This text must explain the action required, e.g. review pricing. Include the timelines that this should be actioned in as well as the applicable clause reference" />
      <mat-error *ngIf="AlertMessageText?.errors?.required">
        Field is required
      </mat-error>
    </mat-form-field>
  </div>

</ng-form>
